import { render, staticRenderFns } from "./FormTour.vue?vue&type=template&id=968c275c&scoped=true"
import script from "./FormTour.vue?vue&type=script&lang=js"
export * from "./FormTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968c275c",
  null
  
)

export default component.exports